import { Title } from '@mantine/core'
import titleClassNames from './styles.module.css'

export default Title.extend({
    defaultProps: { c: undefined },
    classNames: titleClassNames,
})
